export default __webpack_public_path__ + "static/media/shapes.c397dadc.svg";